import Vue from 'vue'
import VueI18n from 'vue-i18n'
import elementEnLocale from 'element-ui/lib/locale/lang/en'
import elementZhLocale from 'element-ui/lib/locale/lang/zh-CN'
import enLocale from '@/lang/en'
import zhLocale from '@/lang/zh'
import { languageZh, languageEn } from '@/utils/const'
import cookie from '@/utils/cookie'

Vue.use(VueI18n)

const messages = {
  en_US: {
    ...enLocale,
    ...elementEnLocale
  },
  zh_CN: {
    ...zhLocale,
    ...elementZhLocale
  }
}

var lang = navigator.language || navigator.userLanguage
lang = lang.substr(0, 2)
var language = ''
if (cookie.getCookie(cookie.language_cookie)) {
  language = cookie.getCookie(cookie.language_cookie)
} else {
  language = lang === 'zh' ? languageZh : languageEn
}

const i18n = new VueI18n({
  // set locale
  // options: en or zh
  locale: language,
  // set locale messages
  messages,
  silentTranslationWarn: true
})

export default i18n



// WEBPACK FOOTER //
// ./src/lang/index.js